import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const usePreviousPath = () => {
  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    prevPathRef.current = location.pathname;
  }, [location.pathname]);

  return prevPathRef.current;
};
